'use strict';

require('core-js/features/promise');
require('core-js/features/object/assign');
